/**
 * P-45L (D-210 / D-214): a service ticket ("קריאה") is opened by the customer
 * only, through the portal. An OTE employee (admin / agent) opens a task or a
 * discussion instead, so every "קריאה חדשה" entry point is hidden from her.
 * The server enforces it (TICKET_CUSTOMER_ONLY); this is the UI mirror.
 */
export function canOpenTicket(user: { role?: string } | null | undefined): boolean {
  return !!user && user.role !== 'admin' && user.role !== 'agent';
}
